
  import { createClient } from 'https://esm.sh/@supabase/supabase-js@2';

  const SUPABASE_URL = import.meta.env?.VITE_SUPABASE_URL || 'https://jwpvvrnofhwfwjllqaff.supabase.co';
  const SUPABASE_ANON = import.meta.env?.VITE_SUPABASE_ANON_KEY || 'sb_publishable_Y_tk868_Bxrj3siz7ABrTA_2X5lVoQ-';
  const sb = createClient(SUPABASE_URL, SUPABASE_ANON, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
  });
  window.sb = sb;

  /* ---------- Profiles cache ---------- */
  const profilesCache = { all: null, byId: new Map(), ts: 0 };
  async function loadProfiles(filtroPapeis) {
    if (!profilesCache.all || (Date.now() - profilesCache.ts) > 60000) {
      const { data, error } = await sb.from('profiles').select('id, nome, papel').order('nome');
      if (error) { console.warn('loadProfiles', error); return []; }
      profilesCache.all = data || [];
      profilesCache.byId = new Map(profilesCache.all.map(p => [p.id, p]));
      profilesCache.ts = Date.now();
    }
    if (filtroPapeis && filtroPapeis.length) {
      return profilesCache.all.filter(p => filtroPapeis.includes(p.papel));
    }
    return profilesCache.all;
  }
  function profileLabel(p) { return `${p.nome} · ${p.papel}`; }
  window.loadProfiles = loadProfiles;
  window.profileLabel = profileLabel;
  window.fillProfileSelect = async function (selectEl, { papeis, selectedId, placeholder } = {}) {
    if (!selectEl) return;
    const list = await loadProfiles(papeis);
    const opts = [`<option value="">${placeholder || '— selecionar —'}</option>`]
      .concat(list.map(p => `<option value="${p.id}" ${p.id === selectedId ? 'selected' : ''}>${profileLabel(p)}</option>`));
    selectEl.innerHTML = opts.join('');
  };

  /* ---------- Auth UI ---------- */
  const $ = (id) => document.getElementById(id);
  const authScreen = $('auth-screen');
  const authForm = $('auth-form');
  const authError = $('auth-error');
  const authSubmit = $('auth-submit');
  let authMode = 'signin';

  function setAuthMode(mode) {
    authMode = mode;
    document.querySelectorAll('[data-auth-tab]').forEach(b => {
      b.classList.toggle('active', b.dataset.authTab === mode);
    });
    document.querySelectorAll('[data-only]').forEach(el => {
      el.hidden = el.dataset.only !== mode;
    });
    $('auth-title').textContent = mode === 'signup' ? 'Criar conta' : 'Entrar na plataforma';
    $('auth-sub').textContent = mode === 'signup'
      ? 'Cadastre sua conta interna Lynq.'
      : 'Use sua conta Lynq para continuar.';
    authSubmit.textContent = mode === 'signup' ? 'Criar conta' : 'Entrar';
    $('auth-senha').autocomplete = mode === 'signup' ? 'new-password' : 'current-password';
    authError.style.display = 'none';
  }
  document.querySelectorAll('[data-auth-tab]').forEach(b => {
    b.addEventListener('click', () => setAuthMode(b.dataset.authTab));
  });

  function showAuthError(msg) {
    authError.textContent = msg;
    authError.style.display = 'block';
    authError.style.background = '';
    authError.style.color = '';
  }
  function showAuthMessage(msg) {
    authError.textContent = msg;
    authError.style.display = 'block';
    authError.style.background = 'var(--success-soft)';
    authError.style.color = 'var(--success)';
  }
  function resetAuthNotice() {
    authError.textContent = '';
    authError.style.display = 'none';
    authError.style.background = '';
    authError.style.color = '';
  }

  authForm.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    resetAuthNotice();
    authSubmit.disabled = true;
    const email = $('auth-email').value.trim();
    const senha = $('auth-senha').value;
    try {
      if (authMode === 'signup') {
        const nome = $('auth-nome').value.trim();
        const papel = $('auth-papel').value;
        if (!nome) throw new Error('Informe seu nome.');
        const { data, error } = await sb.auth.signUp({
          email, password: senha,
          options: { data: { nome, papel } },
        });
        if (error) throw error;
        if (!data.session) {
          showAuthMessage('Conta criada. Se o Supabase pedir confirmação, verifique seu e-mail antes de entrar.');
        }
      } else {
        const { error } = await sb.auth.signInWithPassword({ email, password: senha });
        if (error) throw error;
      }
    } catch (err) {
      showAuthError(err.message || 'Erro ao autenticar.');
    } finally {
      authSubmit.disabled = false;
    }
  });

  $('logout-btn').addEventListener('click', async () => {
    await sb.auth.signOut();
  });

  async function applySession(session) {
    if (!session) {
      window.currentProfile = null;
      profilesCache.all = null;
      document.body.classList.add('auth-locked');
      document.body.classList.remove('auth-checking');
      setAuthMode('signin');
      return;
    }

    // garante que o profile existe (trigger handle_new_user pode demorar)
    let { data: prof, error } = await sb.from('profiles').select('id, nome, papel').eq('id', session.user.id).maybeSingle();
    if (error) console.warn('profile load', error);
    if (!prof) {
      const meta = session.user.user_metadata || {};
      const nome = meta.nome || (session.user.email || '').split('@')[0] || 'Usuário Lynq';
      const papel = meta.papel || 'cs';
      const { error: upsertError } = await sb.from('profiles').upsert({ id: session.user.id, nome, papel });
      if (upsertError) console.warn('profile upsert', upsertError);
      prof = { id: session.user.id, nome, papel };
    }
    document.body.classList.remove('auth-locked');
    document.body.classList.remove('auth-checking');
    const info = $('user-info');
    const avatar = $('user-avatar');
    const papelLabel = { fundador: 'Fundador', admin: 'Admin', comercial: 'Comercial', cs: 'CS', frame: 'Frame' }[prof.papel] || prof.papel;
    if (info) info.textContent = `${prof.nome} · ${papelLabel}`;
    if (avatar) avatar.textContent = (prof.nome || '?').split(' ').map(s => s[0]).slice(0, 2).join('').toUpperCase();
    window.currentProfile = prof;
    document.body.classList.toggle('is-admin', ['fundador','admin'].includes(prof.papel));
    profilesCache.all = null; // re-fetch under authenticated session
    if (typeof window.onAuthReady === 'function') {
      try { await window.onAuthReady(prof); } catch (e) { console.warn(e); }
    }
  }

  (async () => {
    try {
      const { data: { session: initialSession } } = await sb.auth.getSession();
      await applySession(initialSession);
    } catch (error) {
      console.warn('auth init', error);
      document.body.classList.add('auth-locked');
      document.body.classList.remove('auth-checking');
      showAuthError('Não foi possível carregar a sessão. Tente entrar novamente.');
    }
  })();

  sb.auth.onAuthStateChange((_event, session) => { applySession(session); });

  /* ============== LEADS DATA LAYER ============== */
  function dbToLead(row) {
    return {
      id: row.id,
      nome: row.nome || '',
      empresa: row.empresa || '',
      contato: row.contato || '',
      email: row.email || '',
      origem: row.origem || '',
      canalTipo: row.canal_tipo || '',
      segmento: row.segmento || '',
      valor: row.valor != null ? Number(row.valor) : 0,
      estagio: row.estagio || 'captacao',
      entradaEstagio: row.entrada_estagio ? new Date(row.entrada_estagio).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' }).replace(',', ' ·') : '',
      respId: row.responsavel_id || null,
      resp: row.responsavel_nome || '—',
      bant: { N: row.bant_n, A: row.bant_a, B: row.bant_b, T: row.bant_t },
      decisor: row.decisor,
      gestorEspera: row.gestor_espera || null,
      reuniaoFase: row.reuniao_fase || null,
      teste: row.teste || null,
      nurture: row.nurture || null,
      noShow: row.no_show || null,
      perda: row.perda || null,
      proxima: row.proxima || '',
      followup: row.followup || '',
      acaoStatus: row.acao_status || null,
      historico: row.historico || '',
      faturamento: row.faturamento || '',
      leadsMes: row.leads_mes || '',
      dorPrincipal: row.dor_principal || '',
    };
  }
  function leadToDb(l) {
    return {
      nome: l.nome,
      empresa: l.empresa,
      contato: l.contato,
      email: l.email,
      origem: l.origem,
      canal_tipo: l.canalTipo || null,
      segmento: l.segmento,
      valor: l.valor || null,
      estagio: l.estagio,
      responsavel_id: l.respId || null,
      bant_n: l.bant?.N ?? null,
      bant_a: l.bant?.A ?? null,
      bant_b: l.bant?.B ?? null,
      bant_t: l.bant?.T ?? null,
      decisor: l.decisor ?? null,
      gestor_espera: l.gestorEspera || null,
      reuniao_fase: l.reuniaoFase || null,
      teste: l.teste || null,
      nurture: l.nurture || null,
      no_show: l.noShow || null,
      perda: l.perda || null,
      proxima: l.proxima || null,
      followup: l.followup || null,
      acao_status: l.acaoStatus || null,
      historico: l.historico || '',
      faturamento: l.faturamento || null,
      leads_mes: l.leadsMes || null,
      dor_principal: l.dorPrincipal || null,
    };
  }
  function isUuid(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
  }

  window.leadsAPI = {
    async load() {
      const { data, error } = await sb.from('vw_leads').select('*').order('created_at', { ascending: false });
      if (error) { console.warn('leads load', error); return []; }
      return (data || []).map(dbToLead);
    },
    async create(lead) {
      const payload = leadToDb(lead);
      const profileId = window.currentProfile?.id || null;
      payload.created_by = isUuid(profileId) ? profileId : null;
      const { data, error } = await sb.from('leads').insert(payload).select('id').single();
      if (error) { console.warn('leads create', error); throw error; }
      return data.id;
    },
    async updateStage(id, estagio, extras = {}) {
      const patch = { estagio, entrada_estagio: new Date().toISOString() };
      // sync optional state that o moveLeadToStage seta
      if ('teste' in extras) patch.teste = extras.teste;
      if ('nurture' in extras) patch.nurture = extras.nurture;
      if ('perda' in extras) patch.perda = extras.perda;
      if ('proxima' in extras) patch.proxima = extras.proxima;
      if ('acaoStatus' in extras) patch.acao_status = extras.acaoStatus;
      if ('reuniaoFase' in extras) patch.reuniao_fase = extras.reuniaoFase;
      const { error } = await sb.from('leads').update(patch).eq('id', id);
      if (error) console.warn('updateStage', error);
    },
    async remove(id) {
      const { error } = await sb.from('leads').delete().eq('id', id);
      if (error) { alert('Erro ao remover: ' + error.message); throw error; }
    },
    async save(lead) {
      if (!lead.id) return;
      const { error } = await sb.from('leads').update(leadToDb(lead)).eq('id', lead.id);
      if (error) console.warn('save lead', error);
    },
  };

  // Envia o avanço de estágio para a API de Conversões da Meta (Edge Function capi-event).
  // Falha aqui nunca bloqueia o CRM — só fica no console.
  window.sendMetaStage = async function (lead, estagio, value) {
    if (!lead || !lead.id || lead.localOnly) return;
    const { error } = await sb.functions.invoke('capi-event', {
      body: { lead_id: lead.id, estagio, ...(value ? { value } : {}) },
    });
    if (error) console.warn('capi-event', estagio, error);
  };

  // debounce por lead para não floodar updates em mutações rápidas
  const _persistTimers = new Map();
  window.persistLead = function (lead) {
    if (!lead || !lead.id || lead.localOnly) return;
    clearTimeout(_persistTimers.get(lead.id));
    _persistTimers.set(lead.id, setTimeout(() => {
      window.leadsAPI.save(lead);
      _persistTimers.delete(lead.id);
      // Lead qualificado (BANT completo): devolve pra Meta uma vez por sessão.
      // O event_id é fixo por lead no capi-event, então repetir não conta duas vezes.
      try {
        if (typeof bantOK === 'function' && bantOK(lead) && !lead._qualMeta) {
          lead._qualMeta = true;
          window.sendMetaStage?.(lead, 'qualificado');
        }
      } catch (e) { /* nunca bloqueia o CRM */ }
    }, 300));
  };

  /* ============== PARCERIAS DATA LAYER ============== */
  // Uma linha por parceria em public.parcerias (mesmo modelo de leads).
  function dbToParceria(r) {
    return {
      id: r.id,
      empresa: r.empresa || '',
      status: r.status || 'prospeccao',
      tipo: r.tipo || '',
      contato: r.contato || '',
      inicio: r.inicio || '',
      link: r.link || '',
      condicoes: r.condicoes || '',
      obs: r.obs || '',
      responsavel: r.responsavel || '',
      proximoPasso: r.proximo_passo || '',
      proximoData: r.proximo_data || '',
      potencial: r.potencial || '',
      indicacoes: r.indicacoes == null ? '' : String(r.indicacoes),
      cadencia: String(r.cadencia ?? 0),
      ultimoToque: r.ultimo_toque || '',
      whatsapp: r.whatsapp || '',
      mensagem: r.mensagem || '',
      historico: Array.isArray(r.historico) ? r.historico : [],
      origem: r.origem || 'crm',
    };
  }
  function parceriaToDb(p) {
    const n = v => (v === '' || v == null ? null : v);
    return {
      empresa: p.empresa || '',
      status: p.status,
      tipo: n(p.tipo),
      contato: n(p.contato),
      inicio: n(p.inicio),
      link: n(p.link),
      condicoes: n(p.condicoes),
      obs: n(p.obs),
      responsavel: n(p.responsavel),
      proximo_passo: n(p.proximoPasso),
      proximo_data: n(p.proximoData),
      potencial: n(p.potencial),
      indicacoes: p.indicacoes === '' || p.indicacoes == null ? null : Number(p.indicacoes) || 0,
      cadencia: Number(p.cadencia) || 0,
      ultimo_toque: n(p.ultimoToque),
      whatsapp: n(p.whatsapp),
      mensagem: n(p.mensagem),
      historico: p.historico || [],
    };
  }

  window.parceriasAPI = {
    async load() {
      const { data, error } = await sb.from('parcerias').select('*').order('created_at', { ascending: true });
      if (error) { console.warn('parcerias load', error); return []; }
      return (data || []).map(dbToParceria);
    },
    async create(p) {
      const payload = parceriaToDb(p);
      const profileId = window.currentProfile?.id || null;
      payload.created_by = isUuid(profileId) ? profileId : null;
      const { data, error } = await sb.from('parcerias').insert(payload).select('*').single();
      if (error) { console.warn('parcerias create', error); throw error; }
      return dbToParceria(data);
    },
    async save(p) {
      if (!p.id) return;
      const { error } = await sb.from('parcerias').update(parceriaToDb(p)).eq('id', p.id);
      if (error) console.warn('parcerias save', error);
    },
    async remove(id) {
      const { error } = await sb.from('parcerias').delete().eq('id', id);
      if (error) { alert('Erro ao remover: ' + error.message); throw error; }
    },
  };

  /* ============== CS DATA LAYER ============== */
  // expostos no window: usados também por scripts normais (renderCsFilas/openClienteCS)
  function isoToBR(s) {
    if (!s) return '';
    // 'YYYY-MM-DD' → 'DD/MM/YYYY'
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    return s;
  }
  function brToIso(s) {
    if (!s) return null;
    const m = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(s);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    return null;
  }
  window.isoToBR = isoToBR;
  window.brToIso = brToIso;
  function tsRelativo(ts) {
    if (!ts) return '';
    const d = new Date(ts);
    if (isNaN(d)) return '';
    const diff = Date.now() - d.getTime();
    const min = Math.round(diff / 60000);
    if (min < 1) return 'agora';
    if (min < 60) return `há ${min} min`;
    const h = Math.round(min / 60);
    if (h < 24) return `há ${h}h`;
    const dias = Math.round(h / 24);
    if (dias < 30) return `há ${dias} ${dias === 1 ? 'dia' : 'dias'}`;
    return d.toLocaleDateString('pt-BR');
  }

  function dbToCs(row) {
    return {
      id: row.id,
      nome: row.nome || '',
      imobiliaria: row.imobiliaria || '',
      whatsapp: row.whatsapp || '',
      plano: row.plano || 'Starter',
      duracao: row.duracao || 'mensal',
      valorMensal: row.valor_mensal != null ? Number(row.valor_mensal) : 0,
      dataInicio: isoToBR(row.data_inicio),
      comoEntrou: row.como_entrou || 'reuniao',
      ativo: row.ativo !== false,
      saudeManual: row.saude_manual || 'saudavel',
      alertaMotivo: row.alerta_motivo || '',
      resultadoEntregue: row.resultado_entregue || '',
      proximaAcao: row.proxima_acao || '',
      proximaAcaoData: isoToBR(row.proxima_acao_data),
      responsavelId: row.responsavel_id || null,
      responsavel: row.responsavel_nome || row.responsavel || '—',
      leadOrigemId: row.lead_origem_id || null,
      leadOrigemNome: row.lead_origem_nome || null,
      leadOrigemRespId: row.lead_origem_resp_id || null,
      ultimaInteracaoEm: row.ultima_interacao_em || null,
      interacoes: [],
    };
  }
  function csToDb(c) {
    return {
      nome: c.nome,
      imobiliaria: c.imobiliaria,
      whatsapp: c.whatsapp,
      plano: c.plano,
      duracao: c.duracao || 'mensal',
      valor_mensal: Number(c.valorMensal) || null,
      data_inicio: brToIso(c.dataInicio) || new Date().toISOString().slice(0,10),
      como_entrou: c.comoEntrou,
      ativo: c.ativo,
      saude_manual: c.saudeManual || 'saudavel',
      alerta: (c.saudeManual === 'risco'),
      alerta_motivo: c.alertaMotivo || null,
      resultado_entregue: c.resultadoEntregue || '',
      proxima_acao: c.proximaAcao || null,
      proxima_acao_data: brToIso(c.proximaAcaoData),
      responsavel_id: c.responsavelId || null,
      responsavel: c.responsavel || null,
      lead_origem_id: c.leadOrigemId || null,
      lead_origem_nome: c.leadOrigemNome || null,
      lead_origem_resp_id: c.leadOrigemRespId || null,
      ultima_interacao_em: c.ultimaInteracaoEm || null,
    };
  }

  window.csAPI = {
    async load() {
      const { data, error } = await sb.from('vw_clientes_cs').select('*').order('created_at', { ascending: false });
      if (error) { console.warn('cs load', error); return []; }
      const clientes = (data || []).map(dbToCs);
      const ids = clientes.map(c => c.id);
      if (ids.length) {
        const { data: intRows } = await sb.from('interacoes_cs').select('*').in('cliente_id', ids).order('data', { ascending: false });
        const grouped = new Map();
        (intRows || []).forEach(r => {
          const arr = grouped.get(r.cliente_id) || [];
          arr.push({ id: r.id, data: isoToBR(r.data), dataISO: r.data, tipo: r.tipo, desc: r.descricao });
          grouped.set(r.cliente_id, arr);
        });
        clientes.forEach(c => c.interacoes = grouped.get(c.id) || []);
      }
      return clientes;
    },
    async create(cli) {
      const payload = csToDb(cli);
      const { data, error } = await sb.from('clientes_cs').insert(payload).select('id').single();
      if (error) { alert('Erro ao criar cliente: ' + error.message); throw error; }
      return data.id;
    },
    async save(cli) {
      if (!cli.id) return;
      const { error } = await sb.from('clientes_cs').update(csToDb(cli)).eq('id', cli.id);
      if (error) console.warn('cs save', error);
    },
    async addInteracao(cliId, tipo, descricao, dataISO) {
      const data = dataISO || new Date().toISOString().slice(0,10);
      const { error } = await sb.from('interacoes_cs').insert({ cliente_id: cliId, tipo, descricao, data });
      if (error) { console.warn('cs interacao', error); return null; }
      await sb.from('clientes_cs').update({ ultima_interacao_em: data }).eq('id', cliId);
      return { data: isoToBR(data), tipo, desc: descricao };
    },
    async deleteInteracao(intId) {
      const { error } = await sb.from('interacoes_cs').delete().eq('id', intId);
      if (error) console.warn('cs del interacao', error);
    },
    async remove(cliId) {
      await sb.from('interacoes_cs').delete().eq('cliente_id', cliId);
      const { error } = await sb.from('clientes_cs').delete().eq('id', cliId);
      if (error) { alert('Erro ao excluir: ' + error.message); throw error; }
    },
  };

  const _csPersistTimers = new Map();
  window.persistCs = function (cli) {
    if (!cli || !cli.id) return;
    clearTimeout(_csPersistTimers.get(cli.id));
    _csPersistTimers.set(cli.id, setTimeout(() => {
      window.csAPI.save(cli);
      _csPersistTimers.delete(cli.id);
    }, 300));
  };

  /* ============== CONTEUDOS (textos editáveis) ============== */
  window.conteudosAPI = {
    cache: new Map(),
    async loadAll() {
      const { data, error } = await sb.from('conteudos').select('*');
      if (error) { console.warn('conteudos load', error); return; }
      (data || []).forEach(r => this.cache.set(r.chave, r.valor));
    },
    get(chave) { return this.cache.get(chave); },
    async save(chave, valor) {
      this.cache.set(chave, valor);
      const updated_by = window.currentProfile?.id || null;
      const { error } = await sb.from('conteudos').upsert({ chave, valor, updated_by });
      if (error) console.warn('conteudos save', error);
    },
  };

  /* Aplica todos os textos persistidos aos contenteditable[data-conteudo-key] */
  window.applyConteudos = function () {
    document.querySelectorAll('[data-conteudo-key]').forEach(el => {
      const k = el.dataset.conteudoKey;
      const v = window.conteudosAPI.cache.get(k);
      if (v != null) el.innerHTML = v;
    });
  };

  /* Liga auto-save em blur para qualquer contenteditable com data-conteudo-key.
     Liga uma única vez por elemento. */
  function attachConteudoAutosave() {
    document.querySelectorAll('[data-conteudo-key]:not([data-conteudo-bound])').forEach(el => {
      el.setAttribute('data-conteudo-bound', '1');
      el.setAttribute('contenteditable', 'true');
      el.addEventListener('blur', () => {
        const k = el.dataset.conteudoKey;
        const v = el.innerHTML;
        if (window.conteudosAPI.cache.get(k) !== v) {
          window.conteudosAPI.save(k, v);
        }
      });
    });
  }
  window.attachConteudoAutosave = attachConteudoAutosave;

  // Hook: chamado pelo app principal quando o usuário entra autenticado.
  window.onAuthReady = async (profile) => {
    try {
      // Conteúdos primeiro: ao aplicar textos editáveis a gente quer ter os valores
      await window.conteudosAPI.loadAll();
      window.applyConteudos();
      window.attachConteudoAutosave();
      if (typeof window.hydrateFunilFromBackend === 'function') window.hydrateFunilFromBackend();
      if (typeof window.hydrateParceriasFromBackend === 'function') window.hydrateParceriasFromBackend();

      // Leads
      if (typeof window.LEADS !== 'undefined') {
        const list = await window.leadsAPI.load();
        window.LEADS.length = 0;
        list.forEach(l => window.LEADS.push(l));
        if (typeof window.hydrateLocalLeads === 'function') window.hydrateLocalLeads();
      }
      // Clientes CS
      if (typeof window.CLIENTES_CS !== 'undefined') {
        const cs = await window.csAPI.load();
        window.CLIENTES_CS.length = 0;
        cs.forEach(c => window.CLIENTES_CS.push(c));
      }
      if (typeof window.refreshCommercialViews === 'function') window.refreshCommercialViews();
      if (typeof window.renderCarteiraCS === 'function') window.renderCarteiraCS();
      if (typeof window.refreshProspectLists === 'function') window.refreshProspectLists();
      if (typeof window.renderRouteFromLocation === 'function') window.renderRouteFromLocation(false);
    } catch (e) { console.warn('onAuthReady', e); }
  };

  /* ============== ROADMAP ============== */
  const ROADMAP_STATUSES = ['backlog', 'planejado', 'desenvolvimento', 'concluido'];
  const ROADMAP_MOD_LABEL = {
    plataforma: 'Plataforma', comercial: 'Comercial', clientes: 'Clientes',
    financeiro: 'Financeiro', prospeccoes: 'Prospecções', marketing: 'Marketing',
  };
  let ROADMAP_ITEMS = [];
  const roadmapFilters = { modulo: '', prioridade: '' };
  let roadmapEditingId = null;
  let roadmapScope = 'produto';
  const ROADMAP_SCOPE_COPY = {
    produto: {
      h: 'Pendências Gabriel',
      s: 'Kanban de pendências de produto e plataforma. Arraste cards entre colunas para mudar o status.',
    },
    externo: {
      h: 'Pendências Pedro',
      s: 'Kanban de pendências de comercial, marketing e operação. Arraste cards entre colunas para mudar o status.',
    },
  };

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  async function loadRoadmap() {
    const { data, error } = await sb.from('roadmap_items')
      .select('*')
      .order('status', { ascending: true })
      .order('posicao', { ascending: true })
      .order('created_at', { ascending: true });
    if (error) { console.warn('roadmap load', error); return; }
    ROADMAP_ITEMS = data || [];
  }

  /* ============== CONFIG: USUÁRIOS ============== */
  const PAPEIS_DISPONIVEIS = [
    ['fundador', 'Fundador'],
    ['admin', 'Admin'],
    ['comercial', 'Comercial'],
    ['cs', 'CS'],
    ['frame', 'Frame'],
  ];

  window.renderConfigUsers = renderConfigUsers;
  async function renderConfigUsers() {
    const body = document.getElementById('config-users-body');
    if (!body) return;
    body.innerHTML = `<tr><td colspan="4" class="muted" style="padding:18px;text-align:center;">Carregando usuários…</td></tr>`;
    const { data, error } = await sb.rpc('admin_list_users');
    if (error) {
      body.innerHTML = `<tr><td colspan="4" class="muted" style="padding:18px;text-align:center;color:#B91C1C;">Sem permissão para listar usuários.</td></tr>`;
      console.warn('admin_list_users', error);
      return;
    }
    if (!data?.length) {
      body.innerHTML = `<tr><td colspan="4" class="muted" style="padding:18px;text-align:center;">Nenhum usuário cadastrado.</td></tr>`;
      return;
    }
    const meuId = window.currentProfile?.id;
    body.innerHTML = data.map(u => {
      const isMe = u.id === meuId;
      const dt = new Date(u.created_at).toLocaleDateString('pt-BR');
      return `
        <tr>
          <td>
            <strong>${u.nome || '—'}</strong>${isMe ? '<span class="you-badge">você</span>' : ''}
            <div class="muted" style="font-size:11px;margin-top:2px;">${u.email || '—'}</div>
          </td>
          <td>
            <select data-papel-id="${u.id}" ${isMe ? 'disabled' : ''}>
              ${PAPEIS_DISPONIVEIS.map(([v,l]) => `<option value="${v}" ${u.papel === v ? 'selected' : ''}>${l}</option>`).join('')}
            </select>
          </td>
          <td class="muted">${dt}</td>
          <td style="text-align:right;">
            ${isMe ? '<span class="muted" style="font-size:11px;">—</span>' : `<button class="btn btn-danger" data-del-user="${u.id}" data-del-name="${(u.nome||'').replace(/"/g,'&quot;')}" type="button">Remover</button>`}
          </td>
        </tr>
      `;
    }).join('');

    body.querySelectorAll('[data-papel-id]').forEach(sel => {
      sel.addEventListener('change', async () => {
        const id = sel.dataset.papelId;
        const novoPapel = sel.value;
        const { error } = await sb.from('profiles').update({ papel: novoPapel }).eq('id', id);
        if (error) {
          alert('Erro ao atualizar papel: ' + error.message);
          renderConfigUsers();
        }
      });
    });

    body.querySelectorAll('[data-del-user]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = btn.dataset.delUser;
        const nome = btn.dataset.delName;
        if (!confirm(`Remover o perfil de "${nome}"? A conta de autenticação não é apagada, apenas o perfil/papel.`)) return;
        const { error } = await sb.from('profiles').delete().eq('id', id);
        if (error) { alert('Erro ao remover: ' + error.message); return; }
        renderConfigUsers();
      });
    });
  }

  function renderRoadmap() {
    const copy = ROADMAP_SCOPE_COPY[roadmapScope] || ROADMAP_SCOPE_COPY.produto;
    const headEl = document.getElementById('roadmap-heading');
    const subEl = document.getElementById('roadmap-subhead');
    if (headEl) headEl.textContent = copy.h;
    if (subEl) subEl.textContent = copy.s;
    ROADMAP_STATUSES.forEach(status => {
      const zone = document.querySelector(`.roadmap-col-body[data-dropzone="${status}"]`);
      const countEl = document.querySelector(`.roadmap-col[data-status="${status}"] [data-count]`);
      if (!zone) return;
      const items = ROADMAP_ITEMS
        .filter(i => (i.escopo || 'produto') === roadmapScope)
        .filter(i => i.status === status)
        .filter(i => !roadmapFilters.modulo || i.modulo === roadmapFilters.modulo)
        .filter(i => !roadmapFilters.prioridade || i.prioridade === roadmapFilters.prioridade);
      if (countEl) countEl.textContent = items.length;
      if (!items.length) {
        zone.innerHTML = '<div class="roadmap-empty">Sem itens</div>';
        return;
      }
      zone.innerHTML = items.map(i => `
        <article class="roadmap-card" draggable="true" data-id="${i.id}">
          <div class="roadmap-card-head">
            <span class="roadmap-card-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16"/><path d="M4 12h11"/><path d="M4 18h7"/></svg>
            </span>
            <div class="roadmap-card-title">${escapeHtml(i.titulo)}</div>
          </div>
          ${i.descricao ? `<div class="roadmap-card-desc">${escapeHtml(i.descricao)}</div>` : ''}
          <div class="roadmap-card-meta">
            <span class="roadmap-chip prio-${i.prioridade}">${i.prioridade}</span>
            <span class="roadmap-chip mod">${escapeHtml(ROADMAP_MOD_LABEL[i.modulo] || i.modulo)}</span>
            ${i.autor_nome ? `<span class="roadmap-card-author">${escapeHtml(i.autor_nome)}</span>` : ''}
          </div>
        </article>
      `).join('');
    });
    bindRoadmapCardEvents();
  }
  window.renderRoadmap = renderRoadmap;

  function bindRoadmapCardEvents() {
    document.querySelectorAll('.roadmap-card').forEach(card => {
      card.addEventListener('click', () => openRoadmapModal(card.dataset.id));
      card.addEventListener('dragstart', (e) => {
        card.classList.add('dragging');
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', card.dataset.id);
      });
      card.addEventListener('dragend', () => card.classList.remove('dragging'));
    });
  }

  document.querySelectorAll('.roadmap-col-body').forEach(zone => {
    zone.addEventListener('dragover', (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      zone.classList.add('drag-over');
    });
    zone.addEventListener('dragleave', () => zone.classList.remove('drag-over'));
    zone.addEventListener('drop', async (e) => {
      e.preventDefault();
      zone.classList.remove('drag-over');
      const id = e.dataTransfer.getData('text/plain');
      const newStatus = zone.dataset.dropzone;
      const item = ROADMAP_ITEMS.find(i => i.id === id);
      if (!item || item.status === newStatus) return;
      item.status = newStatus;
      renderRoadmap();
      const { error } = await sb.from('roadmap_items').update({ status: newStatus }).eq('id', id);
      if (error) { console.warn('roadmap update status', error); alert('Não foi possível mover o card.'); await loadRoadmap(); renderRoadmap(); }
    });
  });

  /* ----- modal ----- */
  const rmBackdrop = document.getElementById('roadmap-modal-backdrop');
  function openRoadmapModal(id) {
    roadmapEditingId = id || null;
    const item = id ? ROADMAP_ITEMS.find(i => i.id === id) : null;
    document.getElementById('roadmap-modal-title').textContent = item ? 'Editar pendência' : 'Nova pendência';
    document.getElementById('rm-id').value = item?.id || '';
    document.getElementById('rm-escopo').value = item?.escopo || roadmapScope;
    document.getElementById('rm-titulo').value = item?.titulo || '';
    document.getElementById('rm-descricao').value = item?.descricao || '';
    document.getElementById('rm-modulo').value = item?.modulo || 'plataforma';
    document.getElementById('rm-prioridade').value = item?.prioridade || 'media';
    document.getElementById('rm-status').value = item?.status || 'backlog';
    document.getElementById('rm-delete').style.display = item ? 'inline-flex' : 'none';
    rmBackdrop.classList.add('open');
    rmBackdrop.setAttribute('aria-hidden', 'false');
    setTimeout(() => document.getElementById('rm-titulo').focus(), 50);
  }
  function closeRoadmapModal() {
    rmBackdrop.classList.remove('open');
    rmBackdrop.setAttribute('aria-hidden', 'true');
    roadmapEditingId = null;
  }
  document.getElementById('roadmap-modal-close')?.addEventListener('click', closeRoadmapModal);
  document.getElementById('rm-cancel')?.addEventListener('click', closeRoadmapModal);
  rmBackdrop?.addEventListener('click', (e) => { if (e.target === rmBackdrop) closeRoadmapModal(); });
  document.getElementById('roadmap-new-btn')?.addEventListener('click', () => openRoadmapModal(null));

  document.getElementById('roadmap-form')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const payload = {
      escopo: document.getElementById('rm-escopo').value,
      titulo: document.getElementById('rm-titulo').value.trim(),
      descricao: document.getElementById('rm-descricao').value.trim() || null,
      modulo: document.getElementById('rm-modulo').value,
      prioridade: document.getElementById('rm-prioridade').value,
      status: document.getElementById('rm-status').value,
    };
    if (!payload.titulo) return;
    const saveBtn = document.getElementById('rm-save');
    saveBtn.disabled = true;
    try {
      if (roadmapEditingId) {
        const { error } = await sb.from('roadmap_items').update(payload).eq('id', roadmapEditingId);
        if (error) throw error;
      } else {
        payload.autor_id = window.currentProfile?.id || null;
        payload.autor_nome = window.currentProfile?.nome || null;
        const { error } = await sb.from('roadmap_items').insert(payload);
        if (error) throw error;
      }
      await loadRoadmap();
      setRoadmapScope(payload.escopo);
      closeRoadmapModal();
    } catch (err) {
      console.warn('roadmap save', err);
      alert('Não foi possível salvar: ' + (err.message || err));
    } finally {
      saveBtn.disabled = false;
    }
  });

  document.getElementById('rm-delete')?.addEventListener('click', async () => {
    if (!roadmapEditingId) return;
    if (!confirm('Excluir esta feature do roadmap?')) return;
    const { error } = await sb.from('roadmap_items').delete().eq('id', roadmapEditingId);
    if (error) { alert('Não foi possível excluir: ' + error.message); return; }
    await loadRoadmap();
    renderRoadmap();
    closeRoadmapModal();
  });

  function setRoadmapScope(scope) {
    roadmapScope = scope;
    document.querySelectorAll('#roadmap-scope-tabs .roadmap-scope-tab').forEach(t => {
      t.classList.toggle('is-active', t.dataset.escopo === scope);
    });
    renderRoadmap();
  }
  document.querySelectorAll('#roadmap-scope-tabs .roadmap-scope-tab').forEach(tab => {
    tab.addEventListener('click', () => setRoadmapScope(tab.dataset.escopo));
  });

  document.getElementById('roadmap-filter-modulo')?.addEventListener('change', (e) => {
    roadmapFilters.modulo = e.target.value;
    renderRoadmap();
  });
  document.getElementById('roadmap-filter-prioridade')?.addEventListener('change', (e) => {
    roadmapFilters.prioridade = e.target.value;
    renderRoadmap();
  });

  // carga inicial assim que houver sessão
  const prevOnAuthReady = window.onAuthReady;
  window.onAuthReady = async (profile) => {
    if (prevOnAuthReady) await prevOnAuthReady(profile);
    try {
      await loadRoadmap();
      renderRoadmap();
    } catch (e) { console.warn('roadmap init', e); }
  };
